import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconCashPayment = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <StyledPath d="M0.75 14.25V23.25" color="none" />
            <StyledPath
                d="M0.75 21.75H17.25C17.25 20.9544 16.9339 20.1913 16.3713 19.6287C15.8087 19.0661 15.0456 18.75 14.25 18.75H10.5C10.5 17.9544 10.1839 17.1913 9.62132 16.6287C9.05871 16.0661 8.29565 15.75 7.5 15.75H0.75"
                color="none"
            />
            <StyledPath d="M6.75 18.75H10.5" color="none" />
            <StyledPath
                d="M18.1 4.48002H15.93C15.7474 4.47469 15.5656 4.50539 15.3949 4.57037C15.2243 4.63534 15.068 4.73331 14.9352 4.85869C14.8024 4.98406 14.6956 5.13438 14.621 5.30104C14.5463 5.46771 14.5052 5.64746 14.5 5.83002C14.5047 6.10529 14.5934 6.37255 14.7542 6.59597C14.9151 6.81939 15.1404 6.98829 15.4 7.08002L17.6 7.92002C17.8596 8.01175 18.0849 8.18065 18.2458 8.40407C18.4066 8.62749 18.4953 8.89476 18.5 9.17002C18.4948 9.35258 18.4537 9.53233 18.379 9.699C18.3044 9.86567 18.1976 10.016 18.0648 10.1414C17.932 10.2667 17.7757 10.3647 17.6051 10.4297C17.4344 10.4947 17.2526 10.5254 17.07 10.52H14.9"
                color="none"
            />
            <StyledPath d="M16.5 4.48V3.25" color="none" />
            <StyledPath d="M16.5 11.75V10.52" color="none" />
            <StyledPath
                d="M16.5 14.25C20.2279 14.25 23.25 11.2279 23.25 7.5C23.25 3.77208 20.2279 0.75 16.5 0.75C12.7721 0.75 9.75 3.77208 9.75 7.5C9.75 11.2279 12.7721 14.25 16.5 14.25Z"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
